// extracted by mini-css-extract-plugin
export default {"container":"main_container__FT6MR","wrapper":"main_wrapper__m4BXz"};